import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { setAlert } from '../../helpers/alerts';
import { apiCreateBranch } from '../../api/branches';

export default function NewBranchDialog(props) {
    const { onClose, open } = props;
    const [nightlyEnabled, setNightlyEnabled] = useState(false);
    const [createTestInstance, setCreateTestInstance] = useState(true);

    const handleClose = () => {
        setNightlyEnabled(false);
        setCreateTestInstance(true);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                component: 'form',
                onSubmit: (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const formJson = Object.fromEntries(formData.entries());
                    formJson.nightly_enabled = nightlyEnabled;
                    formJson.deploy_target = createTestInstance ? 'test-argo' : '';
                    apiCreateBranch(formJson).then((r) => {
                        setAlert('New branch', `Branch ${r.branch.version} created`, 'success');
                    }).catch((e) => {
                        setAlert('Ooops', e, 'danger');
                    });
                    handleClose();
                },
            }}
        >
            <DialogTitle sx={{ fontSize: '1.5rem' }}>New branch</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="version"
                        label="Version (e.g. 1.12)"
                        type="text"
                        variant="standard"
                        fullWidth
                        required
                    />
                    <TextField
                        margin="dense"
                        name="source_branch"
                        label="Source branch"
                        defaultValue="main"
                        type="text"
                        variant="standard"
                        fullWidth
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={createTestInstance}
                                onChange={(e) => setCreateTestInstance(e.target.checked)}
                            />
                        }
                        label="Create test instance"
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={nightlyEnabled}
                                onChange={(e) => setNightlyEnabled(e.target.checked)}
                            />
                        }
                        label="Enable nightly builds"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="error">Cancel</Button>
                <Button type="submit" color="success">Create</Button>
            </DialogActions>
        </Dialog>
    );
}
